import { container } from "tsyringe";
import ControlEvent from "../../core/control/event/ControlEvent";
import { SlotGameEvent } from "../../slots/control/event/SlotGameEvent";
import { HistoryReplayDetails } from "./HistoryReplayDetails"
import SlotMachine from "../../slots/model/SlotMachine";
import { SlotMachineState } from "../../slots/model/SlotMachineState";
import Wallet from "../../slots/model/Wallet";

export class HistoryReplay {

    private _betDetails: HistoryReplayDetails[]
    private _totalTransact: number = 0
    private _spinsCount: number = -1;
    private _enabled: boolean = false;
    private _betId: number = 0
    public _skipreplay: boolean = false

    public isReplayScreenActive: boolean = false

    constructor() {
        this._betDetails = []
    }

    get spinsCount(): number {
        return this._spinsCount;
    }

    set spinsCount(value: number) {
        this._spinsCount = value
    }

    get betID(): number {
        return this._betId;
    }

    set betID(value: number) {
        this._betId = value
    }


    get enabled(): boolean {
        if (this.spinsCount == this._totalTransact) {
            this._enabled = false
        }
        return this._enabled;
    }

    set enabled(value: boolean) {
        if (this._enabled == value) {
            return;
        }

        this._enabled = value;
    }

    play(details: HistoryReplayDetails[]) : void {
        const sm = container.resolve(SlotMachine)
        const wallet = container.resolve(Wallet);

        wallet.balance = sm.replayData.initialBalance;
        // this.betID = id
        this.spinsCount = -1
        this.enabled = true
        this._betDetails = details
        this._totalTransact = details.length - 1
        this.isReplayScreenActive = true

        sm.currentState = SlotMachineState.REPLAY_START
        new ControlEvent(SlotGameEvent.SPIN_START).dispatch();
    }

    getBetDetails(i: number): HistoryReplayDetails {
        return this._betDetails[i]
    }

    stop() : void {
        this.spinsCount = this._totalTransact
    }
}